import { HttpEvent, HttpProgressEvent, HttpResponse, HttpSentEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseServiceClient } from './base-service-client';

@Injectable({
    providedIn: 'root',
})
export class DocumentClientService extends BaseServiceClient {
    private readonly patientApiUrl = this.appConstants.environment.eposvet?.patient?.url;
    private readonly docApiUrl = this.appConstants.environment.eposvet?.document?.url;

    uploadDocument(guid: string, file: File, comment: string): Observable<HttpEvent<HttpSentEvent | HttpProgressEvent | HttpResponse<string>>> {
        const url = `${this.ApiBaseUrl}${this.patientApiUrl}/upload/token/${guid}`;
        return this.uploadFile(url, file, comment);
    }

    getDocumentById(documentId: string): Observable<Blob> {
        const url = `${this.ApiBaseUrl}${this.docApiUrl}/contractors/0/documents/${documentId}`;
        return this.get<Blob>(url, { responseType: 'blob' });
    }
}
